<section
  *ngIf="mode && mode !== transportMode.Unknown; else notAvailableTransportModeTemplate"
  class="tw-flex tw-gap-x-2"
>
  <ui-svg-icon [name]="iconsMap.get(mode)" [matTooltip]="!showText ? mode : ''" class="transport-mode"></ui-svg-icon>
  <span *ngIf="showText" class="tw-self-center">{{ mode }}</span>
</section>

<ng-template #notAvailableTransportModeTemplate>
  <span>
    <span *ngIf="isNoteAvailableTitleVisible">{{ 'monitoring.filters.transportModes' | translate }}:</span>
    <ng-content></ng-content>
    <span *ngIf="!hasProjectedContent">{{ notAvailable }}</span>
  </span>
</ng-template>
